module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Semibold-203d78b0.ttf";